export * from './tipo-empresa.pipe';
